module.exports = __webpack_public_path__ + "img/NC_jinsong_2021.fb4f4be8.png";